import type { FormSchema } from '@cli-types/core-engine/schema.js'
import { hasFormSchemaTitleField } from './has-form-schema-title-field.js'

export function collectMissingFormSchemaTitleErrors(schema: FormSchema, errors: string[]): void {
  if (hasFormSchemaTitleField(schema)) return
  errors.push(`Form schema "${schema.name}" must define a text-compatible field named "title".`)
}
